import { EnvironmentInterface } from '@nutt/configuration';

export const environment: EnvironmentInterface = {
  isProduction: false,
  apiBaseUrl: 'https://loohuis.nutt.test.m4mapp.com/api/',
  clientId: '8f205e37683045bcf3cbd384f8d8fd59',
  avatarBaseUrl: 'https://nutt-loohuis-test-a0o0g.s3.eu-west-1.amazonaws.com/',
};
